import { absolutePath } from "./absolutePath";

const BASE_PATH = "connect/connection/my_connections";

interface IndexParams {
  page?: number;
  per_page?: number;
}

export const myConnections = {
  index: (params: IndexParams = {}) => absolutePath(BASE_PATH, params),
};
